



import Vue from 'vue'
import { SensorData, SensorDataTypes } from '../../../services/SensorData';

export default Vue.extend({
    name: 'current-light',

    data: () => ({
        sensorDataService: new SensorData(),

        value: 0,
    }),

    created() {
        this.sensorDataService.filterData( SensorDataTypes.T_LIGHT, 'desc', 1 )
        .then(
            ( res: any ) => this.value = res.data[0]['reading'],
            () => {}
        );
    }

})
